import React, { useContext, useEffect, useState } from 'react';
import { Store } from '../Store';
import { addToOrder, removeFromOrder } from '../actions';
import { setPaymentType, generateQrCode, getCheckoutUrl } from '../actions';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Dialog,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { useStyles } from '../styles';
import App from "../App";
import SignUp from './SignUp';
import { useHistory } from "react-router-dom"; 
import Axios from 'axios';
import config,{ getParameterByName,merchantCode} from '../util';

export default function ReviewScreen(props) {
  const styles = useStyles();
  const { state, dispatch } = useContext(Store);
  const { orderItems, itemsCount, totalPrice, taxPrice, orderType } = state.order;
  const selectedCurrency = state.selectedCurrency;
  
  let { setting } = state.userSetting;
  const [quantity, setQuantity] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [product, setProduct] = useState({});
  const [addons, setAddons] = useState([]);
  let loggedUser = sessionStorage.getItem("customerInfo");
  loggedUser = loggedUser && JSON.parse(loggedUser);
  const [openSign, setOpenSign] = useState(loggedUser&&loggedUser.user?true:false);
  const history = useHistory();
  let { userInfo } = state.userData;
  const getCurrency = userInfo ? userInfo.currency : "";
  const getPercent = setting ? setting.taxPercent : "";
  let items = [];
  let addonsItems = {};
  let currSymbol= {
    'usd':"$",
    'inr':"₹"
  }
    const baseURL = config.baseURL;
   console.log(orderItems);
   console.log(userInfo);

  if (orderItems.length) {
    orderItems.forEach((oi) => {
      items.push({
        quantity: oi.quantity,
        "item":{"id": oi._id},
        price: oi.price * 100 + (oi.price * getPercent / 100) * 100
      });
      //let itemsAdons= {};
      //itemsAdons[oi._id] = oi.addons
      addonsItems[oi._id]= oi.addons;
      return true;
    });
  }

  const closeHandler = () => {
    setIsOpen(false);
  };



  const productClickHandler = (p) => {
    let existingOrder = orderItems.filter(o => o._id === p._id);
    setProduct(p);
    setAddons(JSON.parse(p.sub_pro));
    if (existingOrder.length) {
      setQuantity(existingOrder[0].quantity);
    } else {
      setQuantity(1);
    }
    setIsOpen(true);
  };

  const addToOrderHandler = () => {
    addToOrder(dispatch, { ...product, quantity });
    setIsOpen(false);
  };

  const cancelOrRemoveFromOrder = () => {
    removeFromOrder(dispatch, product);
    setIsOpen(false);
  };

  // let metadata = {};
  // items.forEach((item) => {
  //   metadata[item.inventory_id] = JSON.stringify(addonsItems);
  // });

  const procedToCheckoutHandler = () => {
    let runningOrder = localStorage.getItem('runningOrder');
   
    if (loggedUser !== null && runningOrder) {
      runningOrder = JSON.parse(runningOrder);
      let orderInit = {
        "metadata":runningOrder.metadata,
        "email":loggedUser.customer.email,
        "currency": setting.currency
      }
      console.log(orderInit);
      let ordItems = [];
      ordItems = orderItems.map(oi => {return {"item":{"id":oi._id},"price": oi.price*100, "quantity":oi.quantity}});
      ordItems={"items": ordItems};
      console.log(ordItems);
      let modifiers=addonsItems;
      console.log(modifiers);

      let finalOrder = [orderInit,ordItems,modifiers];
      localStorage.setItem("finalOrder",JSON.stringify(finalOrder));
      //placeFinalOrderToClover(finalOrder);
      history.push("/payment?"+ window.location.href.split('?')[1]);
     // history.push("/complete?"+ window.location.href.split('?')[1]);
    } else {
      setOpenSign(true); 
    }
    //props.setIsPaneOpen(false);
  };


const placeFinalOrderToClover = async (finalOrder) => {
    try {
      let merchantDtl=JSON.parse(localStorage.getItem('userInfo'));
      let subPath = "/api/clover/ecom/orders?merchantCode=";
      Axios.post(`${baseURL}${subPath}${merchantDtl.merchantCode}`,finalOrder).then(res=>{
         history.push("/complete?"+ window.location.href.split('?')[1]);
      });
    }
    catch (error) {
      console.log(error);

    }
  };


  const adAddons = (adId) => {
    let existingItem = product;
    let adOns = JSON.parse(existingItem.sub_pro).map((ad) => {
      if (ad._id === adId) {
        ad.quantity = ad.quantity + 1;
      }
      return ad;
    });
    setAddons(adOns);
    existingItem.sub_pro = JSON.stringify(adOns);
    setProduct(existingItem);
  };

  const removeAddons = (adId) => {
    let existingItem = product;
    let adOns = JSON.parse(existingItem.sub_pro).map((ad) => {
      if (ad._id === adId) {
        ad.quantity = ad.quantity - 1;
      }
      return ad;
    });
    setAddons(adOns);
    existingItem.sub_pro = JSON.stringify(adOns);
    setProduct(existingItem);
  };

 if(!setting){
    setting=JSON.parse(localStorage.getItem("userInfo"));
  }

  return (
    <Box 
    style={{
      backgroundColor:setting.themeColor,
      width:"100%"
    }}
    
    >
      <Box className={[styles.main, styles.center]} style={{ justifyContent: "start",width:"100%" }}>
        <Dialog
          onClose={closeHandler}
          aria-labelledby="max-width-dialog-title"
          open={isOpen}
          fullWidth={true}
          maxWidth={state.widthScreen ? 'sm' : 'xs'}
        >
          <DialogTitle className={styles.center}>
            Add {product.name}
          </DialogTitle>
          <Box className={[styles.row, styles.center,styles.countHolder]}>
            <Button className={styles.minus}
              variant="contained"
              color="primary"
              disabled={quantity === 1}
              onClick={(e) => quantity > 1 && setQuantity(quantity - 1)}
            >
              <RemoveIcon />
            </Button>
            <TextField
              inputProps={{ className: styles.largeInput }}
              className={styles.largeNumber}
              type="number"
              min={1}
              variant="filled"
              value={quantity}
            />
            <Button className={styles.add}
              variant="contained"
              color="primary"
              onClick={(e) => setQuantity(quantity + 1)}
            >
              <AddIcon />
            </Button>
          </Box>
          <Box style={{ margin: "10px" }}>
            <h5 style={{ textAlign: "center" }}>{addons.length >= 1 ? "Add-ons" : ""}</h5>
            {addons.length >= 1 ? addons.map(li => (
              <div style={{ display: "flex", justifyContent: "space-between", alignContent: "center", padding: "3px 15px", fontSize: "20px", flexWrap: "wrap" }}>
                {li.name} <div className={styles.btn_group}>
                  <span>{currSymbol[selectedCurrency]} {li.price} </span>
                  <span className={styles.addons}>
                    <button className={styles.minus1} onClick={() => removeAddons(li._id)}><RemoveIcon /></button>
                    {li.quantity}
                    <button className={styles.plus} onClick={() => adAddons(li._id)}> <AddIcon sx={{ fontSize: "1px" }} /></button>
                  </span>
                </div>
              </div>
            ))
              : ""}
          </Box>
          <Box className={[styles.row, styles.around]} >
            <Button
              onClick={cancelOrRemoveFromOrder}
              variant="outlined"
              color="primary"
              size="large"
              className={[styles.largeButton, styles.card]}
            >
              {orderItems.find((x) => x.name === product.name) ? 'Remove' : 'Cancel'}
            </Button>
            <Button
              onClick={addToOrderHandler}
              variant="contained"
              color="primary"
              size="large"
              className={styles.largeButton}
            >
              ADD
            </Button>
          </Box>
        </Dialog>
        <Box >
          
        </Box>

        <Box style={{width:"100%"}}>
          <Grid container style={{width:"100%"}}>
            {orderItems.map((orderItem) => (
              <Grid item key={orderItem.name} style={{width:"100%"}}>
                <Card

  onClick={() => productClickHandler(orderItem)}
  style={{
    marginBottom: "20px",
    backgroundColor: setting.themeTxtColor,
    color:"black",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    padding:"0px 10px",
    minHeight: "100px"  
  }}
>


 <img
  src={`https://cloverstatic.com/menu-assets/items/${orderItem._id}.jpeg`}
  alt={orderItem.name}
  style={{
    width: "80px",
    height: "80px",
    objectFit: "cover",
    borderRadius: "5px",

  }}
  onError={(e) => { e.target.src = "/images/blank.png" }}
/>


 <Box style={{ flex: 1 }}>
  <Typography
    variant="h6"
    style={{ fontWeight: 600, color: "#ffffff", fontSize: "18px" }}
  >
    {orderItem.name}
  </Typography>
  <Typography
    variant="body2"
    style={{ color: "#fff", fontSize: "14px", marginTop: "2px", fontFamily: setting.themeSecondaryFontFam }}
  >
    {addonsItems[orderItem._id]?.map(mod => mod.name).join(", ")}
  </Typography>
  <Typography
    variant="body2"
    style={{ marginTop: "6px", fontWeight: 500, color: "#000", fontSize: "16px" }}
  >
    {currSymbol[selectedCurrency]}{orderItem.price/100}
  </Typography>
</Box>

  {/* Quantity selector */}
<Box
  style={{
    display: "flex",
    flexDirection: "column",  // stack vertically
    alignItems: "center",
    marginLeft: "10px",
     fontFamily: setting.themeSecondaryFontFam
  }}
>
  
<Button
    onClick={(e) => {
      e.stopPropagation();
      setProduct(orderItem);
      setQuantity(orderItem.quantity + 1);
      addToOrder(dispatch, { ...orderItem, quantity: orderItem.quantity + 1 });
    }}
    style={{
      backgroundColor: "#CE9760",
      color: "#000",
      minWidth: "40px",
       fontFamily: setting.themeSecondaryFontFam,
      height: "40px",
      borderRadius: "50%",
    }}
  >
    <KeyboardArrowUpIcon/>
  </Button>
  <Typography
    style={{
      width: "28px",
      textAlign: "center",
      fontSize: "16px",
       fontFamily: setting.themeSecondaryFontFam,
      margin: "8px",
      fontWeight:"bold"
    }}
  >
    {orderItem.quantity}
  </Typography>
<Button
    onClick={(e) => {
      e.stopPropagation();
      setProduct(orderItem);
      setQuantity(orderItem.quantity - 1);
      if(orderItem.quantity==1){
        removeFromOrder(dispatch,orderItem);
      }else{
      addToOrder(dispatch, { ...orderItem, quantity: orderItem.quantity - 1 });
      }
    }}
  
    style={{
      backgroundColor: "#CE9760",
      color: "#000",
      minWidth: "40px",
      height: "40px",
      borderRadius: "50%",
       fontFamily: setting.themeSecondaryFontFam,
      marginBottom: "8px",
    }}
  >
   <KeyboardArrowDownIcon/>
  </Button>
  
</Box>
</Card>

              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      <Box style={{ width:"100%",height:"100px" }}>
      
          <Box  style={{ textAlign: 'center', fontSize: '20px', lineHeight: "40px", color:setting.themeTxtColor, fontFamily: setting.themeSecondaryFontFam }}>
            Tax: {currSymbol[selectedCurrency]}{(taxPrice/100).toFixed(2)} | Total: {currSymbol[selectedCurrency]}{(totalPrice/100).toFixed(2)} | Items: {itemsCount}
          </Box>
          <Box className={[styles.row, styles.around]} style={{width:"100%",marginTop:"30px", marginBottom:"10px"}}>
            <Button
              onClick={procedToCheckoutHandler}
              variant="contained"
              disabled={orderItems.length === 0}
              style={{color:setting.themeColor,backgroundColor:setting.themeTxtColor,fontWeight:"800", fontFamily: setting.themeSecondaryFontFam}}
            >
             Proceed To Checkout
            </Button>
          </Box>
        </Box>
    
      {openSign && !loggedUser && <Dialog open={true} fullWidth maxWidth="sm">
  <SignUp log={true} setOpenSign={setOpenSign} procedToCheckoutHandler={procedToCheckoutHandler}/>
</Dialog>}

    </Box>
  );
}
